import { LitEntity, html } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';
import './work-order-reschedule';

class WorkOrderRescheduleModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'work-order-reschedule-modal';
  }

  static get properties() {
    return {
      action: { type: Object },
    };
  }

  renderContents() {
    return html`
      <style>
        bn-modal#${this.id} {
          --modal-min-width: 50%;
          --modal-max-width: 50%;
          --modal-min-height: auto;
        }
      </style>
      <h3 slot="title">Reschedule Work Order</h3>
      <work-order-reschedule .href="${this.href}" @response="${this._onResponse}"></work-order-reschedule>
    `;
  }

  _onResponse(e) {
    this.close();
    this.dispatchEvent(new CustomEvent('response', { detail: e.detail }));
  }
}

window.customElements.define('work-order-reschedule-modal', WorkOrderRescheduleModal);
